import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import BookPromo from "../components/BookPromo";
import Podcast from "../components/Podcast";
import CoreValues from "../components/CoreValues";
import Salvation from "../components/Salvation";
import Mission from "../components/Mission";
import News from "../components/News";
import Footer from "../components/Footer";
import Team from "../components/Team";

export default function AboutUs() {
  return (
    <div>
      <Header />
      <hr className="g-brd-gray-light-v4 my-0" />

      <main>
        <Hero />
        <About />
        <Team />
        <BookPromo />
        <Podcast />
        <CoreValues />
        <Salvation />
        <Mission />
        <News />
      </main>

      <Footer />
    </div>
  );
}